import Role from 'models/core/role/Model.Role';
import Model from 'models/Model';
import Provider from 'models/productManagement/provider/Model.Provider';
import ProviderStatementBalanceEmailTemplateAttachment from '../providerStatementBalanceEmailTemplateAttachment/Model.ProviderStatementBalanceEmailTemplateAttachment';
import StatementBalanceEmailTemplate from '../statementBalanceEmailTemplate/Model.StatementBalanceEmailTemplate';
import providerStatementBalanceEmailTemplateListApi from './list/Api.ProviderStatementBalanceEmailTemplate.List';
import providerStatementBalanceEmailTemplateSaveApi from './save/Api.ProviderStatementBalanceEmailTemplate.Save';
import providerStatementBalanceEmailTemplateDeleteApi from './delete/Api.ProviderStatementBalanceEmailTemplate.Delete';

export default class ProviderStatementBalanceEmailTemplate
  extends Model<Model.IProviderStatementBalanceEmailTemplate>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IProviderStatementBalanceEmailTemplate>
{
  id: number;
  name: string;
  statementBalanceStatusTrigger: Model.Enum.StatementStatusCode;
  senderEmail: string;
  senderName: string;
  sendToRepresentative: boolean;
  sendToDealersAccounting: boolean;
  subject: string;
  htmlBody: string;
  recipientsWithRole?: Role[];
  additionalRecipientEmails: string[] = [];
  attachments?: ProviderStatementBalanceEmailTemplateAttachment[];

  languageIsoCode?: Locale.Languages;
  readonly baseEntityId: number;

  statementBalanceEmailTemplate: StatementBalanceEmailTemplate;
  statementBalanceEmailTemplateId: number;
  provider: Provider;
  providerId: number;

  constructor(
    data:
      | Partial<Model.IProviderStatementBalanceEmailTemplate>
      | Utils.FormData<Model.IProviderStatementBalanceEmailTemplate>,
    language?: Locale.Languages
  ) {
    super(
      {
        recipientsWithRole: [Role],
        attachments: [ProviderStatementBalanceEmailTemplateAttachment],
        provider: Provider,
        statementBalanceEmailTemplate: StatementBalanceEmailTemplate,
      },
      language
    );
    this.update(data);
    if (!this.additionalRecipientEmails) this.additionalRecipientEmails = [];
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name,
      info: this.senderName,
      subtitle: this.senderEmail,
    };
  }
  static async list(body?: Api.Core.ProviderStatementBalanceEmailTemplate.List.IRequest) {
    const { payload, ...rest } = await providerStatementBalanceEmailTemplateListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ProviderStatementBalanceEmailTemplate(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await providerStatementBalanceEmailTemplateSaveApi(this);
  }
  async delete() {
    return await providerStatementBalanceEmailTemplateDeleteApi(this.id);
  }
}
